import type {VersionInfo} from './app/utils.class';

export const compiledVersion: VersionInfo = {"buildNumber":"D. van der Steen B.V_acceptance_2026-11-04_11-0-13","buildId":"24874","environment":"dvds-acceptance","datetime":"2026-11-04T10:02:03.620Z","checkForUpdates":true}